import BasicLayout from "@/layouts/basic-layout";

const meta = {
    auth: false,
    cache: false,
};
export default {
    path: "/house",
    name: "/house",
    redirect: {
        name: "house",
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: "/house/list",
            name: "houseList",
            meta: {
                ...meta,
                title: "楼栋管理",
                cache: true,
            },
            component: () => import("@/pages/house/index.vue"),
        },
        {
            path: "/house/houseDetails",
            name: "houseDetails",
            meta: {
                ...meta,
                title: "新增楼栋",
                cache: true,
            },
            component: () => import("@/pages/house/houseDetails.vue"),
        },
    ],
};
